import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  //base: "/esmcc",
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('../components/login.vue')
  },
  {
    path: '/main',
    component: () => import('../components/esmain.vue'),
    children: [{
      path: '/main/home',
      component: () => import('../components/eshome.vue')
    }]
  },
  {
    path: '/dashboardmain',
    component: () => import('../components/statistic/dashboardmain.vue'),
    redirect: '/dashboardoutline',
    children: [{
      path: '/dashboardoutline',
      component: () => import('../components/statistic/dashboardoutline.vue')
    }, {
      path: '/dashboardfault',
      component: () => import('../components/statistic/dashboardfault.vue')
    }, {
      path: '/dashboardrepair',
      component: () => import('../components/statistic/dashboardrepair.vue')
    }]
  }
  ]
})